import React, { Component } from "react"
import { Box, useTheme } from "datastory-shared/ui"

import chart from "./line-chart"

class ChartWrapper extends Component {
  componentDidMount() {
    this.chart = chart()
    this.chart.create(this.holder, this.props)
  }

  componentDidUpdate() {
    this.chart.update(this.props)
  }

  componentWillUnmount() {
    this.chart.destroy()
  }

  render() {
    return <div ref={holder => (this.holder = holder)} />
  }
}

const Chart = props => {
  const { colors, fonts } = useTheme()
  return (
    <Box
      css={{
        ".tick text": {
          fontSize: "0.875rem",
          fontFamily: fonts.body,
          fill: colors.gray[700],
        },
        ".line.party": {
          strokeLinejoin: "bevel",
          strokeWidth: "3px",
          fill: "transparent",
        },
        ".axis--x .tick line": {
          stroke: "none",
        },
        ".axis--y line": {
          stroke: colors.gray[100],
        },

        ".axis--y .domain,& .axis--x .domain": {
          stroke: "transparent",
        },
        ".tick": {
          position: "relative",
          marginTop: 0,
          background: "transparent",
        },
        ".tick:first-child": {
          transform: "translateX(-25%) !important",
        },
      }}
    >
      <ChartWrapper colors={colors} {...props} />
    </Box>
  )
}

export default Chart
